export const principles = {
  title: "Nuestros principios",
  subtitle: "¿Qué nos hace diferentes?",
  bookVisit: "Reserva una visita",
  items: {
    environment: {
      title: "Entorno preparado",
      description: "Espacios diseñados para promover la autonomía, concentración y aprendizaje activo"
    },
    respect: {
      title: "Respeto mutuo",
      description: "Base de nuestra comunidad educativa, fomentando relaciones sanas y resolución pacífica de conflictos"
    },
    learning: {
      title: "Aprendizaje activo",
      description: "Los niños construyen su conocimiento a través de experiencias concretas y significativas"
    },
    international: {
      title: "Perspectiva internacional",
      description: "Educación trilingüe (español, inglés, gallego) y multicultural"
    },
    attention: {
      title: "Atención individualizada",
      description: "Ratio reducida que permite adaptarnos al ritmo y necesidades de cada estudiante"
    },
    development: {
      title: "Desarrollo integral",
      description: "Atención equilibrada a capacidades académicas, emocionales, sociales y físicas"
    }
  }
};
